module.exports = __webpack_public_path__ + "img/015.6dc29950.jpg";